import type {
  OpeningEventMethod,
  OpeningSessionDisplayStatus,
  PaginatedOpeningSessions,
} from '@gozoki/api-types'
import { gozokiApiWithAuth } from '../gozokiApi'

export interface FetchOpeningSessionsParams {
  page?: number
  perPage?: number
  storeId?: number
  status?: OpeningSessionDisplayStatus
  method?: OpeningEventMethod
  from?: string
  to?: string
}

export const fetchOpeningSessions = async (params?: FetchOpeningSessionsParams) => {
  const response = await gozokiApiWithAuth.get<PaginatedOpeningSessions>('/opening-sessions', {
    params,
  })
  return response.data
}
